import * as yup from 'yup';

import { assertNestedOptionLeaf } from '~/core/shared/components/form/NestedSelect';
import type {
  WorkflowStepFormFieldBlock,
  WorkflowStepFormFieldValidationRules,
} from '../../types';
import type { NestedOption } from '../../types/utility';

type WorkflowStepFormFieldBlockWithValidationRules = Omit<
  WorkflowStepFormFieldBlock,
  'validationRules'
> & {
  validationRules: WorkflowStepFormFieldValidationRules;
};

export const getYupSchemaForFormFieldBlock = (
  formFieldBlock: WorkflowStepFormFieldBlockWithValidationRules,
) => {
  const componentProps = formFieldBlock.componentProps as
    | Record<string, unknown>
    | undefined;
  const isMultiSelect =
    formFieldBlock.componentType === 'typeahead' && !!componentProps?.isMulti;
  let schema: yup.Schema;
  if (formFieldBlock.componentType === 'file-upload') {
    schema = yup.mixed();
  } else if (isMultiSelect) {
    schema = yup.array().of(yup.string()).nullable();
  } else if (formFieldBlock.componentType === 'nested-select') {
    schema = assertNestedOptionLeaf(
      yup.string(),
      componentProps?.options as readonly NestedOption[] | undefined,
    );
  } else {
    schema = yup.string();
  }

  return formFieldBlock.validationRules?.required
    ? schema
    : schema.notRequired();
};
